module.exports = {
      id: "logos:nswvolunteering-usage",
      viewBox: "0 0 217 16",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#logos:nswvolunteering-usage",
      toString: function () {
        return this.url;
      }
    }